import type { IFindSearchResults } from './find-search-results.model';
import { SearchResultItemApiModel } from './search-result-item.api-model';

export class EpiServerFindSearchResultsApiModel {
  public numberOfFaqResults!: number;
  public numberOfUnifiedResults!: number;
  public items!: SearchResultItemApiModel[];

  public static mapToBusinessModel(apiModel: EpiServerFindSearchResultsApiModel): IFindSearchResults {
    return {
      numberOfFaqResults: apiModel.numberOfFaqResults,
      numberOfUnifiedResults: apiModel.numberOfUnifiedResults,
      items: apiModel.items.map((h) => SearchResultItemApiModel.mapToBusinessModel(h)),
    };
  }
}
